import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import AppRoutes from './routes/index.routes';
import ConsultantCheckoutProvider from './providers/consultantCheckout';

const queryClient = new QueryClient();

function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ConsultantCheckoutProvider>
        <AppRoutes />
      </ConsultantCheckoutProvider>
    </QueryClientProvider>
  );
}

export default App;
